import { OpportunitiesService } from "@/services";
import { CurrencyExchangeRate } from "@/services/DTOs";
import { ActionContext, Module } from "vuex";

export class OpportunityDefinitionState {
  public currenciesExchangeRate: CurrencyExchangeRate[];
  public areGaugesEnabled: boolean;
  public isDragAndDropEnabled: boolean;

  constructor() {
    this.currenciesExchangeRate = [];
    this.areGaugesEnabled = true;
    this.isDragAndDropEnabled = true;
  }
}

export default {
  namespaced: true,
  state: () => new OpportunityDefinitionState(),
  mutations: {
    setCurrenciesExchangeRate(state: OpportunityDefinitionState, data: CurrencyExchangeRate[]) {
      state.currenciesExchangeRate = data;
    },
    setGaugesEnabled(state: OpportunityDefinitionState, data: boolean) {
      state.areGaugesEnabled = data;
    },
    setDragAndDropEnabled(state: OpportunityDefinitionState, data: boolean) {
      state.isDragAndDropEnabled = data;
    },
  },
  actions: {
    init(context: ActionContext<OpportunityDefinitionState, any>): void {
      OpportunitiesService.getCurrenciesExchangeRate()
        .toPromise()
        .then((data) => context.commit("setCurrenciesExchangeRate", data));
    },
    setGaugesEnabled(context: ActionContext<OpportunityDefinitionState, any>, data: boolean): void {
      context.commit("setGaugesEnabled", data);
    },
    setDragAndDropEnabled(context: ActionContext<OpportunityDefinitionState, any>, data: boolean): void {
      context.commit("setDragAndDropEnabled", data);
    },
  },
  getters: {
    areGaugesEnabled(state: OpportunityDefinitionState): boolean {
      return state.areGaugesEnabled;
    },
    isDragAndDropEnabled(state: OpportunityDefinitionState): boolean {
      return state.isDragAndDropEnabled;
    }
  }
} as Module<OpportunityDefinitionState, any>;
